import { useTranslations } from 'next-intl';

import MarkerIcon from '@/fo/icons/base/icons/marker16.svg';
import { utilGetReviewBonusPoints } from '@/fo/util/get-review-bonus-points';

import { styles } from './UiReviewInformerPoints.styles';

export interface UiReviewInformerPointsProps {
  isNewProduct?: boolean;
  className?: string;
  mode?: 'form' | 'list';
}

export function UiReviewInformerPoints({
  isNewProduct = false,
  className,
  mode = 'form'
}: UiReviewInformerPointsProps) {
  const t = useTranslations('review.form.points');
  const slots = styles({ mode });
  const { text, photo } = utilGetReviewBonusPoints(isNewProduct);

  if (mode === 'list') {
    return (
      <div className={slots.base({ className })}>
        <div className={slots.badge({ variant: 'accent' })}>
          <MarkerIcon className={slots.icon()} />
          <span className={slots.text()}>{t('max', { points: photo })}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={slots.base({ className })}>
      <div className={slots.badge({ variant: 'default' })}>
        <MarkerIcon className={slots.icon()} />
        <span className={slots.text()}>{t('text', { points: text })}</span>
      </div>
      <div className={slots.badge({ variant: 'accent' })}>
        <MarkerIcon className={slots.icon()} />
        <span className={slots.text()}>{t('photo', { points: photo })}</span>
      </div>
    </div>
  );
}
